import React, { useContext, useState } from 'react'
import axios from "axios"
import { NavLink, useNavigate } from 'react-router-dom'
import { Store } from '../App';
import './newFormStyles.css';
import AboutImg from "../InnerPages/assets/login.png"

const Admin = () => {
    const[token,setToken]=useContext(Store)
    const[email,setEmail]=useState("")
    const[password,setPassword]=useState("")
    const navigate=useNavigate()
    
    const clearData=()=>{
        setEmail("");
        setPassword("");
    }
    
    const submitHandler=(e)=>{
        e.preventDefault()
       axios
       .post(`https://backendsurgylife-1.onrender.com/login`,{email,password})
       .then((res)=>{
     setToken(res.data.token)
    })
       .catch((err)=>{
        alert("login failed  please check your credentials")
       })
    }

    if(token) {
        navigate("/admindashboard");
    }

  return (
    <div className="admin-container">
      <div className="form-container">
        <p className="form-title">Admin Login</p>
        <form className="login-form" onSubmit={submitHandler}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              name="email" 
              id="email" 
              placeholder="Enter your email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              name="password" 
              id="password" 
              placeholder="Enter your password"
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              required
            />
            <div className="forgot">
              <NavLink to='/forgotpassword'>Forgot Password?</NavLink>
            </div>
          </div>
          
          <div className="remember-group">
            <label>
              <input type="checkbox" /> Remember Me
            </label>
          </div>
          
          <div className="button-group">
            <button type="button" className="cancel-btn " onClick={clearData}>
              Cancel
            </button>
            <button type="submit" className="login-btn">
              Login
            </button>
          </div>
          
          <div className="register-links">
            <p>Don't have an account? <NavLink to='/register'>Register</NavLink></p>
            <p><NavLink to='/resetpassword'>Reset Password</NavLink></p>
          </div>
        </form>
      
      </div>
        {/* <div className='p-5'>
          <img src={AboutImg} alt='logo' className='img-fluid'/>
        </div> */}
    </div>
  )
}

export default Admin
